import dayjs from '~/timeInit';

/**
 * "Data queried 21 Oct 2026, 15:40 (Sydney)" from the latest `refreshedAt` on a Lens data response's cards.
 *
 * `refreshedAt` is when svc-reporting fetched the card (cache fetch time), not when the source table was last
 * refreshed, so it is labelled as a query time. Returns null when no card carries a parseable timestamp.
 */
export function lensQueriedAtLabel(cards: Array<{ refreshedAt?: string }> | undefined | null): string | null {
  const latest = (cards ?? [])
    .map((card) => (card.refreshedAt ? dayjs(card.refreshedAt) : null))
    .filter((d): d is dayjs.Dayjs => !!d && d.isValid())
    .sort((a, b) => b.valueOf() - a.valueOf())[0];
  return latest ? `Data queried ${latest.tz('Australia/Sydney').format('D MMM YYYY, HH:mm')} (Sydney)` : null;
}
